export default __webpack_public_path__ + "static/client-testimonial-jr-ridge-founder-of-guardian-angel-522d9aba54c1ab4d51f587b1b56bfb0e.mp4";